import { useBreakpointValue } from "@chakra-ui/react";

const useDeviceSize = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const isMobileOrTablet = useBreakpointValue({ base: true, lg: false });
  const isTablet = useBreakpointValue({ base: false, md: true, lg: false });
  const isTabletOrDesktop = useBreakpointValue({ base: false, md: true });
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const isDesktopXl = useBreakpointValue({ base: false, xl: true });

  return {
    isMobile,
    isMobileOrTablet,
    isTablet,
    isTabletOrDesktop,
    isDesktop,
    isDesktopXl,
  };
};

export default useDeviceSize;
